import { Bar } from "react-chartjs-2";
import "chartjs-plugin-datalabels";
import { Chart } from "chart.js/auto";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { Fragment } from "react";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
} from 'chart.js';


ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);
Chart.register(ChartDataLabels);

const BarChart = ({ data }) => {
 
  
const formatValue = (value) => {
  if (value >= 1000000000000)
    return `$${(value / 1000000000000).toFixed(1)}T`;
  if (value >= 1000000000) return `$${(value / 1000000000).toFixed(1)}B`;
  if (value >= 1000000) return `$${(value / 1000000).toFixed(1)}M`;
  if (value >= 1000) return `$${(value / 1000).toFixed(1)}K`
  return `$${value.toLocaleString()}`;
};

  const options = {
    responsive: true,
    indexAxis: "y",
    maintainAspectRatio: false, // Allow custom height
    elements: {
      bar: {
        borderWidth: 1,
        barPercentage: 0.8, // Add spacing between bars
        categoryPercentage: 0.9, // Add spacing between groups
      }
  },

    scales: {
      x: {
      beginAtZero: true,
        grid: {
          display: false, // Hide grid lines
        },
        ticks: {
          color: "white",
          callback: function (value) {
            return "$ " + value.toLocaleString(); // Format x-axis labels
          },
        },
      },
      y: {
      grid: {
          display: false, // Hide grid lines
        },
        ticks: {
          color: "white",
          font: {
            size: 11, // Reduce font size to avoid overlap
          },
        },
      },
    },
    plugins: {
      legend: {
        position: "top",
        labels: {
          color: '#ccc', // Replace with your desired color (Tailwind's gray-800)
        
        }
      },
    tooltip: {
      callbacks: {
        label: function (context) {
          const label = context.dataset.label || '';
          const value = context.parsed.x;
          return `${label}: $${value.toLocaleString()}`;
        },
      },
    },
      datalabels: {
        formatter: (value) => formatValue(value),
        color: '#fff',
        font: {
          weight: 'bold',
        },
        anchor: 'end',
        align: 'end',
      },
    },
  };
  return (
    <Fragment>
      <div style={{ height: '500px' }}>
        <Bar id="canvas" data={data} options={options} />
      </div>
      {/* <Issues /> */}
    </Fragment>
  );
};

export default BarChart;
